import React, { useState } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ActionCreators from "../../store/actions";
import { Avatar, Popover, Typography, Switch, makeStyles, useTheme, Divider, MenuItem } from "@material-ui/core";
import MoonIcon from '@material-ui/icons/Brightness3';
import SunIcon from '@material-ui/icons/WbSunny';
import { themeTypeToBool } from "../../utils/helpers";
import { TooltipBottom as CustomTooltip } from "../Common/CustomTooltips";
import t from "../../languages/pl";
import UserDialog from "./UserDialog/UserDialog";

const useStyles = makeStyles(theme => ({
    avatar: {
        marginLeft: 10,
        color: themeTypeToBool(theme.palette.type) ? theme.palette.grey[700] : theme.palette.common.white,
        background: theme.palette.grey[500],
        cursor: "pointer"
    },
    modeSwitch: {
        marginLeft: 10,
        marginRight: 5
    },
    modeIcon: {
        height: 18,
        width: 18
    },
    verticalDivider: {
        height: 35,
        width: 1,
        margin: "0 25px 0 25px",
        background: themeTypeToBool(theme.palette.type) ? theme.palette.grey[700] : theme.palette.common.white
    }
}));

const getUserInitials = username => {
    if (username) {
        let parts = username.split(" ");
        if(parts.length === 1)
            return username[0];
        return parts[0][0] + parts[1][0];
    }
};

const UserAvatar = props => {
    const { themeType, username, usernameChange, passwordChange } = props;
    const theme = useTheme();
    const classes = useStyles(theme);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [userOpen, setUserOpen] = useState(false);

    const handleOpen = event => setAnchorEl(event.currentTarget);

    const handleClose = () => setAnchorEl(null);

    const handleLogoutClick = () => props.logout();

    const onSwitchChange = () => props.changeTheme();

    const handleUsernameChange = (username) => {
        usernameChange(username);
    };

    const handlePasswordChange = (changedPasswordValues) => {
        passwordChange(changedPasswordValues.oldPassword, changedPasswordValues.newPassword);
    };


    return (
        <React.Fragment>
            <SunIcon className={classes.modeIcon} />
            &nbsp;
                <CustomTooltip title={t.themeChange}>
                    <Switch checked={(themeType === "dark") ? true : false}
                        onChange={onSwitchChange}
                        className={classes.modeSwitch}
                        color="primary"
                    />
                </CustomTooltip>
            &nbsp;
                    <MoonIcon className={classes.modeIcon} />
            <Divider orientation="vertical" className={classes.verticalDivider} />
            <Typography variant="body1">
                {username}
            </Typography>
            <Avatar
                className={classes.avatar}
                onClick={handleOpen}
            >
                <Typography variant="h6">
                    {getUserInitials(username)}
                </Typography>
            </Avatar>
            <Popover
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem onClick={() => setUserOpen(true)}>{t.userAccount}</MenuItem>
                <MenuItem onClick={handleLogoutClick}>{t.logout}</MenuItem>
            </Popover>
            <UserDialog
                open={userOpen}
                onClose={() => setUserOpen(false)}
                username={username}
                onUsernameChange={handleUsernameChange}
                onPasswordChange={handlePasswordChange}
            />
        </React.Fragment>
    );
};

const mapStateToProps = state => {
    return {
        themeType: state.requestReducer.themeType,
        username: state.authReducer.username,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreators, dispatch);
};

export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(UserAvatar);

UserAvatar.propTypes = {
    username: PropTypes.string,
    themeType: PropTypes.string,
    changeTheme: PropTypes.func,
    usernameChange: PropTypes.func,
    passwordChange: PropTypes.func,
    logout: PropTypes.func
};